import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { anhBia, anhBiaDoc, linkNhung, linkXem, thoiLuongChu } from "@shared/video.js";
import { tenTrang } from "../lib/videoTrang.js";
import { track } from "../lib/track.js";

/**
 * Ảnh bìa không bao giờ trắng. Thử lần lượt:
 *   1. hq720: ảnh nét, khung dọc của Shorts nằm giữa; CSS cắt giữa nên vừa khung.
 *   2. hqdefault: luôn có, nhỏ hơn.
 *   Ảnh thiếu thì YouTube trả ảnh xám 120x90 chứ không báo lỗi, nên phải đo kích thước.
 *   3. Bìa tự vẽ (nền mực, logo, tên video) khi cả hai đều không tải được.
 * Ảnh có thể tải xong trước khi React gắn sự kiện (trang render sẵn), nên khi
 * gắn xong cũng tự đo lại.
 */
function useAnhBia(id) {
  const thu = [anhBiaDoc(id), anhBia(id)];
  const [i, setI] = useState(0);
  const ref = useRef(null);
  const hong = () => setI((x) => x + 1);
  const kiem = () => { const im = ref.current; if (im && im.complete && im.naturalWidth > 0 && im.naturalWidth <= 120) hong(); };
  useEffect(() => {
    const im = ref.current;
    if (im && im.complete) { if (im.naturalWidth === 0) hong(); else kiem(); }
  }, [i]); // eslint-disable-line react-hooks/exhaustive-deps
  return { src: thu[i] || "", ref, kiem, hong };
}

/**
 * Một video ngắn (YouTube Shorts), dạng thẻ ngang: khung dọc 9:16 bên trái,
 * chữ bên phải. Ban đầu chỉ có ảnh bìa và nút phát; bấm mới tải trình phát
 * YouTube (khoảng 1 MB), ở chế độ youtube-nocookie để YouTube không đặt
 * cookie trước khi người xem chủ động phát. Trang vì vậy vẫn nhẹ và đúng với
 * banner đồng ý cookie.
 *
 * - nhan: dòng chữ nhỏ phía trên tiêu đề ("Xem nhanh 58 giây").
 * - boTrang: đường dẫn không cần ghi "Đọc tiếp" (chính là trang đang mở).
 */
export function TheVideo({ v, nhan, boTrang, tieuDeCap = "h3" }) {
  const [phat, setPhat] = useState(false);
  const bia = useAnhBia(v.id);
  const { pathname } = useLocation();
  const TieuDe = tieuDeCap;
  const docTiep = v.ganVao.filter((p) => p !== boTrang).map((p) => ({ p, ten: tenTrang(p) })).filter((x) => x.ten).slice(0, 2);
  function batDau() {
    setPhat(true);
    track("video_play", { video: v.id, trang: pathname.slice(0, 60) });
  }
  return (
    <article className={`vn-the${phat ? " dang-phat" : ""}`}>
      <div className="vn-khung">
        {phat ? (
          <iframe
            src={linkNhung(v.id)}
            title={v.tieuDe}
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
            allowFullScreen
            loading="lazy"
          />
        ) : (
          <button type="button" className="vn-nut-phat" onClick={batDau} aria-label={`Phát video: ${v.tieuDe}`}>
            {bia.src
              ? <img ref={bia.ref} src={bia.src} alt="" loading="lazy" decoding="async" width="360" height="640" onLoad={bia.kiem} onError={bia.hong} />
              : <span className="vn-bia-ve" aria-hidden="true"><span className="vn-bia-logo">f</span><span className="vn-bia-ten">{v.tieuDe}</span></span>}
            <span className="vn-tam-giac" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg></span>
            {v.thoiLuong ? <span className="vn-thoi-luong">{thoiLuongChu(v.thoiLuong)}</span> : null}
          </button>
        )}
      </div>
      <div className="vn-chu">
        {nhan && <p className="vn-nhan">{nhan}</p>}
        <TieuDe className="vn-tieu-de">{v.tieuDe}</TieuDe>
        {v.moTa && <p className="vn-mo-ta">{v.moTa}</p>}
        {docTiep.length > 0 && (
          <p className="vn-doc-tiep">
            {docTiep.map((x, i) => <span key={x.p}>{i ? ", " : "Đọc kỹ hơn: "}<Link to={x.p}>{x.ten}</Link></span>)}
          </p>
        )}
        <p className="vn-chan">
          {v.loat && <span className="vn-loat">{v.loat}</span>}
          <a href={linkXem(v.id)} target="_blank" rel="noopener noreferrer">Xem trên YouTube ↗</a>
        </p>
      </div>
    </article>
  );
}

/** Khối "Xem nhanh" đặt trong trang từ điển, bài Playbook, trang công cụ. */
export default function XemNhanh({ ds, path }) {
  if (!ds?.length) return null;
  return (
    <section className="vn-xem-nhanh" aria-label="Video ngắn">
      {ds.slice(0, 3).map((v) => (
        <TheVideo key={v.id} v={v} boTrang={path}
          nhan={`Xem nhanh${v.thoiLuong ? ` ${thoiLuongChu(v.thoiLuong)}` : ""}`} />
      ))}
      <p className="vn-tat-ca"><Link to="/video">Tất cả video ngắn →</Link></p>
    </section>
  );
}
